import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import type { HeadingBlock } from '../types';
import styles from './Heading.module.css';
interface HeadingProps {
  block: HeadingBlock;
  blockId: string;
}
const LEVEL_TO_CLASS = {
  1: styles.h1,
  2: styles.h2,
  3: styles.h3,
  4: styles.h4
} as const;
export function Heading(t0) {
  const $ = _c(27);
  const {
    block,
    blockId
  } = t0;
  const t1 = LEVEL_TO_CLASS[block.appearance ?? block.level];
  const t2 = block.variant === "display4" ? styles.display4 : null;
  const t3 = block.variant === "listingTitle" ? styles.listingTitle : null;
  const t4 = block.variant === "listingSection" ? styles.listingSection : null;
  const t5 = block.variant === "listingSectionSmall" ? styles.listingSectionSmall : null;
  const t6 = block.variant === "listingSubheading" ? styles.listingSubheading : null;
  const t7 = block.variant === "listingNumbered" ? styles.listingNumbered : null;
  let t8;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== t6 || $[6] !== t7) {
    t8 = [t1, t2, t3, t4, t5, t6, t7].filter(Boolean);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const className = t8.join(" ");
  let t9;
  if ($[8] !== block.text || $[9] !== block.variant) {
    t9 = block.variant === "listingNumbered" ? renderNumberedHeading(block.text) : block.text;
    $[8] = block.text;
    $[9] = block.variant;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const children = t9;
  let t10;
  if ($[11] !== block.id || $[12] !== blockId || $[13] !== className) {
    t10 = {
      id: block.id,
      className,
      "data-cms-block-id": blockId,
      "data-cms-field": "heading"
    };
    $[11] = block.id;
    $[12] = blockId;
    $[13] = className;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const commonProps = t10;
  if (block.level === 1) {
    let t11;
    if ($[15] !== children || $[16] !== commonProps) {
      t11 = <h1 {...commonProps}>{children}</h1>;
      $[15] = children;
      $[16] = commonProps;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    return t11;
  }
  if (block.level === 2) {
    let t11;
    if ($[18] !== children || $[19] !== commonProps) {
      t11 = <h2 {...commonProps}>{children}</h2>;
      $[18] = children;
      $[19] = commonProps;
      $[20] = t11;
    } else {
      t11 = $[20];
    }
    return t11;
  }
  if (block.level === 3) {
    let t11;
    if ($[21] !== children || $[22] !== commonProps) {
      t11 = <h3 {...commonProps}>{children}</h3>;
      $[21] = children;
      $[22] = commonProps;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    return t11;
  }
  let t11;
  if ($[24] !== children || $[25] !== commonProps) {
    t11 = <h4 {...commonProps}>{children}</h4>;
    $[24] = children;
    $[25] = commonProps;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
}
function renderNumberedHeading(text: string): JSX.Element | string {
  const match = text.match(/^(\d+)\.\s*(.+)$/);
  if (!match) return text;
  return <>
      <span className={styles.numberCircle}>
        {match[1]}.
      </span>
      {' '}
      <span>{match[2]}</span>
    </>;
}